import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-344f519e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "developer-project-card__box" }
const _hoisted_2 = { class: "developer-project-card__title-box" }
const _hoisted_3 = { class: "developer-project-card__title" }
const _hoisted_4 = { class: "developer-project-card__content" }
const _hoisted_5 = { class: "developer-project-card__content-info" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "third-color" }, "Адрес:", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "third-color" }, "Застройщик:", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "underline main-color" }, "Витрина объектов", -1))
const _hoisted_9 = { class: "developer-project-card__bottom-content none-Mobile mt--0 mb--0" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "developer-project-card__modal" }

import { SmallCardLSDType } from '@/types';
import { computed, ref } from 'vue';
import { useAppStore } from '@/store/modules/app';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResidentialComplexCard',
  props: {
    project: {},
    version: {}
  },
  setup(__props: any) {

const props = __props;

const tooltipActive = ref(false);
const title = computed(() => {
  if (props.project.title) {
    let sliced: string = props.project.title.slice(
      0,
      useAppStore().getWindowWidth() > 600 ? 15 : 12,
    );

    if (sliced.length < props.project.title.length) {
      tooltipActive.value = true;
      sliced = sliced + '...';
    }

    return sliced;
  }

  return '-';
});

const addressModal = ref(false);
const addressEl = ref<HTMLElement | undefined>();
const isOverflowed = computed((): boolean => {
  if (addressEl.value) {
    return addressEl.value?.scrollHeight > addressEl.value.offsetHeight;
  }

  return false;
});
const showAddress = () => {
  addressModal.value = true;
};

const goToRCHandler = () => {
  if (!props.project.public) {
    useAppStore().openAlert(
      '',
      'Данная карточка не опубликована, поэтому переход невозможен.',
      'error',
    );
  }
};

return (_ctx: any,_cache: any) => {
  const _component_base_image = _resolveComponent("base-image")!
  const _component_base_tooltip = _resolveComponent("base-tooltip")!
  const _component_base_rating_number = _resolveComponent("base-rating-number")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_card = _resolveComponent("base-card")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_base_card, { class: "developer-project-card" }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.project.url && _ctx.project.public ? 'router-link' : 'button'), {
          to: { name: 'residentialComplex', params: { url: _ctx.project.url } },
          target: "_blank",
          onClick: goToRCHandler
        }, {
          default: _withCtx(() => [
            _createVNode(_component_base_image, {
              name: _ctx.project.title,
              src: _ctx.project.logo,
              title: _ctx.project.title,
              version: _ctx.version,
              "border-radius": "",
              contain: "",
              height: "150",
              width: "100%"
            }, null, 8, ["name", "src", "title", "version"])
          ]),
          _: 1
        }, 8, ["to"])),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _createVNode(_component_base_tooltip, {
                active: tooltipActive.value,
                text: _ctx.project.title
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(title.value), 1)
                ]),
                _: 1
              }, 8, ["active", "text"])
            ]),
            _createVNode(_component_router_link, {
              to: { name: 'classification', query: { id: _ctx.project.id } },
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_base_rating_number, {
                  rating: _ctx.project.coefficient
                }, null, 8, ["rating"])
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _hoisted_6,
                _createElementVNode("div", null, [
                  _createElementVNode("div", {
                    ref_key: "addressEl",
                    ref: addressEl,
                    class: "developer-project-card__content-address"
                  }, _toDisplayString(props.project.address), 513),
                  (isOverflowed.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "main-color",
                        onClick: showAddress
                      }, " Далее "))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_7,
                _createElementVNode("div", null, _toDisplayString(_ctx.project.developerTitle || '-'), 1)
              ]),
              _createElementVNode("div", null, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.project.url && _ctx.project.public ? 'router-link' : 'button'), {
                  to: {
                name: 'residentialComplex',
                params: { url: _ctx.project.url },
                hash: '#ads',
              },
                  onClick: goToRCHandler
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }, 8, ["to"]))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_base_button, {
              href: 
            _ctx.project.url && _ctx.project.public
              ? { name: 'residentialComplex', params: { url: _ctx.project.url } }
              : undefined
          ,
              "all-block-width": "",
              "style-type": "coloredBorder",
              text: "Подробнее",
              onClick: goToRCHandler
            }, null, 8, ["href"]),
            _createVNode(_component_base_button, {
              href: 
            _ctx.project.url && _ctx.project.public
              ? { name: 'residentialComplex', params: { url: _ctx.project.url }, hash: '#map' }
              : undefined
          ,
              icon: "",
              "style-type": "coloredBorder",
              withoutActive: "",
              onClick: goToRCHandler
            }, {
              icon: _withCtx(() => [
                _createElementVNode("img", {
                  src: require('@/assets/img/mainPage/icons/icon-map.png'),
                  alt: "map"
                }, null, 8, _hoisted_10)
              ]),
              _: 1
            }, 8, ["href"])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_base_modal, {
      "show-modal": addressModal.value,
      "close-outside": "",
      "hide-title": "",
      onClose: _cache[0] || (_cache[0] = ($event: any) => (addressModal.value = false))
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.project.address), 1)
      ]),
      _: 1
    }, 8, ["show-modal"])
  ], 64))
}
}

})